import { Box } from "@mui/material";
import { ScoreRating, RiskFactorStats } from "~/operations";
import { ImpactUpdated } from "~/components/impact/Updated/impact-updated";
import { CompactRiskFactorsIcons } from "./CompactRiskFactorsIcons";

export type RiskSummaryValue = {
  rating: ScoreRating | null | undefined;
  riskValue: number | null | undefined;
  riskFactors: Array<RiskFactorStats | null> | null | undefined;
};

type RiskSummaryCellProps = {
  value: RiskSummaryValue | null | undefined;
};

export function RiskSummaryCell({ value }: RiskSummaryCellProps) {
  if (!value) {
    return null;
  }

  const impact = {
    rating: value.rating || ScoreRating.None,
    value: value.riskValue || 0,
  };

  const riskFactors = value.riskFactors?.filter(
    (rf): rf is RiskFactorStats => rf !== null,
  );

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        height: "100%",
        width: "100%",
      }}
    >
      <Box sx={{ mr: 0.75 }}>
        <ImpactUpdated
          impact={impact}
          isActive={true}
          hideTooltip={false}
          showText={false}
        />
      </Box>
      {riskFactors && riskFactors.length > 0 && (
        <CompactRiskFactorsIcons riskFactors={riskFactors} />
      )}
    </Box>
  );
}
